import { Flex } from "@chakra-ui/react";
import { FC } from "react";
import { CircleLoader } from "react-spinners";

export const Loading: FC = () => {
  return (
    <Flex
      position="absolute"
      w="100%"
      height="100%"
      top="0"
      left="0"
      justify="center"
      alignItems="center"
      zIndex="100"
      bg="transparent"
      id="loading"
    >
      <Flex
        justify="center"
        alignItems="center"
        position="relative"
        bg="rgba(0,0,0,0.1)"
        width="100px"
        height="100px"
        borderRadius="10px"
        boxShadow="lg"
      >
        <CircleLoader color="#5383ff" loading size="50px" />
      </Flex>
    </Flex>
  );
};
